<script>
    import R, {LOADER} from "../lib/requests";
    import {clickOutside} from '../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import Icon from "../components/Icon.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import {setFocusTo} from "../lib/lib";

    export let project = null;
    let name = '';
    let results = [];
    let listIndex = -1;
    let timer;
    let showDropdown = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onNameKeydown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter' && listIndex > -1) {
                event.preventDefault();
                selectResult(results[listIndex]);
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onNameKeyup = (event) => {
        if (name !== event.target.value && event.target.value.length) {
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }
            timer = setInterval(() => {
                clearInterval(timer);
                search();
            }, 500);
        }
    }

    const selectResult = (item) => {
        name = item.name;
        project = item;
        dispatch('change', item);
        closeDropdown();
    }

    const search = () => {
        const onSuccess = result => {
            results = result;
        }

        const onFailure = err => {
        };

        R.handle(R.project.index, {name: name}, onSuccess, onFailure);
    }

    const openDropdown = () => {
        showDropdown = true;
        if (project) {
            name = project.name;
            search();
        }
        document.addEventListener('keydown', handleEscapeKey);
        setFocusTo('searchName');
    }

    const closeDropdown = () => {
        if (showDropdown) {
            showDropdown = false;
            results = [];
            listIndex = -1;
            name = '';
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }
</script>

<div class="select-control" use:clickOutside on:click_outside="{ closeDropdown }">
    {#if !project}
        <button class="btn btn-link btn-content-flex ps-1" on:click="{ openDropdown }">
            <Icon name="plus-circle" strokeWidth="2" cssClass="pe-1"/>
            Project
        </button>
    {:else}
        <button class="btn btn-link text-decoration-none ps-1" on:click="{ openDropdown }">
            <ColoredNameControl color="{project.color}" name="{ project.name }" colorName/>
        </button>
    {/if}
    {#if showDropdown}
        <div class="control-dropdown">
            <ul>
                <li class="input-item">
                    <input type="text" class="form-control" id="searchName" value="{ name }"
                           on:keydown="{ onNameKeydown }"
                           on:keyup="{ onNameKeyup }"
                           placeholder="όνομα project">
                </li>
                {#if results.length}
                    <li class="separator"></li>
                    {#each results as item, index}
                        <li class="dropdown-item" class:active="{ listIndex === index }"
                            on:click="{ () => selectResult(item) }">
                            <ColoredNameControl color="{item.color}" name="{ item.name }" colorName/>
                        </li>
                    {/each}
                {/if}
            </ul>
        </div>
    {/if}
</div>

<style>
    .select-control {
        position: relative;
    }

    .select-control .control-dropdown {
        position: absolute;
        width: max-content;
        min-width: 200px;
        background: var(--dropdown-background);
        box-shadow: var(--dropdown-box-shadow);
        z-index: 5000;
    }

    .control-dropdown ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .control-dropdown ul > li.input-item {
        padding: 15px;
    }

    .control-dropdown ul > li.dropdown-item {
        cursor: pointer;
        padding: 10px 10px;
    }

    .control-dropdown ul > li.dropdown-item:hover,
    .control-dropdown ul > li.dropdown-item.active {
        background: var(--dropdown-item-hover-background);
    }

    /*.control-dropdown ul > li.dropdown-button {*/
    /*    text-align: center;*/
    /*    background: var(--dropdown-button-background);*/
    /*    cursor: pointer;*/
    /*    padding: 10px 20px;*/
    /*}*/

    .control-dropdown ul > li.separator {
        border-top: var(--dropdown-separator);
    }
</style>